/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Table/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Table({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Table",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 13,
  height = 13,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  stroke = "#2F8132"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Table.Svg"
  data-view-path={viewPath}
 viewBox="0 0 13 13"
 style={{'--as-1-Z2ixdMu': alignSelf,'--mt-2-Z2ixdMu': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2ixdMu': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2ixdMu': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2ixdMu': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2ixdMu': opacity,'--w-10-Z2ixdMu': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2ixdMu': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2ixdMu': fill,'--a-7-Z2ixdMu': isAnimated ? animation : "none",'--sd-8-Z2ixdMu': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2ixdMu': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Table.SvgPath"
  data-view-path={viewPath}
 d="M11.577.5H1.423a.923.923 0 00-.923.923v10.154c0 .51.413.923.923.923h10.154c.51 0 .923-.413.923-.923V1.423A.923.923 0 0011.577.5zM.5 3.27h12M.5 7.885h12M5.946 3.27v9.23M9.223 3.27v9.23"
 strokeLinecap="round"
 strokeLinejoin="round"
 style={{'--s-13-Z2ixdMu': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}